import enviro from 'enviro';
export function getDebugMode() {
  return Boolean(enviro.debug('data-ops-fullstory'));
}
export function debugLog(...args) {
  if (getDebugMode()) {
    console.log('Data-Ops-Fullstory: ', ...args);
  }
}